var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDotsVertical(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8334 10.4167C20.8334 8.11548 22.6989 6.25 25 6.25C27.3012 6.25 29.1667 8.11548 29.1667 10.4167C29.1667 12.7179 27.3012 14.5833 25 14.5833C22.6989 14.5833 20.8334 12.7179 20.8334 10.4167ZM20.8334 25C20.8334 22.6988 22.6989 20.8333 25 20.8333C27.3012 20.8333 29.1667 22.6988 29.1667 25C29.1667 27.3012 27.3012 29.1667 25 29.1667C22.6989 29.1667 20.8334 27.3012 20.8334 25ZM20.8334 39.5833C20.8334 37.2821 22.6989 35.4167 25 35.4167C27.3012 35.4167 29.1667 37.2821 29.1667 39.5833C29.1667 41.8845 27.3012 43.75 25 43.75C22.6989 43.75 20.8334 41.8845 20.8334 39.5833Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8334 10.4167C20.8334 8.11548 22.6989 6.25 25 6.25C27.3012 6.25 29.1667 8.11548 29.1667 10.4167C29.1667 12.7179 27.3012 14.5833 25 14.5833C22.6989 14.5833 20.8334 12.7179 20.8334 10.4167ZM20.8334 25C20.8334 22.6988 22.6989 20.8333 25 20.8333C27.3012 20.8333 29.1667 22.6988 29.1667 25C29.1667 27.3012 27.3012 29.1667 25 29.1667C22.6989 29.1667 20.8334 27.3012 20.8334 25ZM20.8334 39.5833C20.8334 37.2821 22.6989 35.4167 25 35.4167C27.3012 35.4167 29.1667 37.2821 29.1667 39.5833C29.1667 41.8845 27.3012 43.75 25 43.75C22.6989 43.75 20.8334 41.8845 20.8334 39.5833Z",
    fill: "black",
    fillOpacity: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsVertical);
export default __webpack_public_path__ + "static/media/dotsVertical.f934b4794911762fdd46ccc2a7cfbce0.svg";
export { ForwardRef as ReactComponent };